"use server";

import { migrationEnquiryEmail } from "@/emails/migration-enquiry";
import { clientKey } from "@/lib/client-key";
import { HONEYPOT_FIELD, MigrationInput, flattenErrors, newId, rateLimited, sendStrictMail } from "@cw/forms";

const MIGRATION_RECIPIENT = "edge@pscx.ai";

type MigrationResult = { ok: true; id: string } | { ok: false; errors: Record<string, string> };

export async function submitMigration(raw: {
  name: string;
  email: string;
  organization: string;
  platform: string;
  users: string;
  timing: string;
  website?: string;
}): Promise<MigrationResult> {
  if (typeof raw?.[HONEYPOT_FIELD] === "string" && raw[HONEYPOT_FIELD].trim()) {
    return { ok: true, id: newId() };
  }

  if (rateLimited(await clientKey("pscx:migration"), 10)) {
    return { ok: false, errors: { _form: "Too many requests. Please try again in a while." } };
  }

  const parsed = MigrationInput.safeParse(raw);
  if (!parsed.success) return { ok: false, errors: flattenErrors(parsed.error) };

  const id = newId();
  const data = parsed.data;

  try {
    await sendStrictMail({
      to: MIGRATION_RECIPIENT,
      replyTo: data.email,
      ...migrationEnquiryEmail(data, id),
    });
    return { ok: true, id };
  } catch {
    return {
      ok: false,
      errors: { _form: "We couldn’t send your request. Please email edge@pscx.ai directly." },
    };
  }
}
